const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';

import Vue from 'vue';

Vue.prototype.$http = axios;

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

axios.interceptors.response.use((response) => {
    const {data} = response;
    if (data.notifications) {
        data.notifications.forEach(item => {
            const defaultOptions = {
                okVariant: 'danger',
            };
            const vue = new Vue;
            const options = {...defaultOptions, ...item.options};
            vue.$bvModal.msgBoxOk(item.message, options)
        });
    }
    return response;
}, (err) => {
    throw err;
});